import SelectService from '../service/SelectService';

SelectService.onChange('site-language', (language) => {
    window.location = '/?language=' + language;
});
